// extracted by mini-css-extract-plugin
export default {"tablehead":"ProcessDataTable_tablehead__QuGq5","custom-striped-table":"ProcessDataTable_custom-striped-table__axK8H"};